// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"9e2663b2","734":"1d07a8b3","816":"c85cb566","877":"b29697e3","892":"207ffaa4"}[chunkId] + ".chunk.js";
};